import { render, staticRenderFns } from "./FreeTabIndex.vue?vue&type=template&id=2f4345d4"
import script from "./FreeTabIndex.vue?vue&type=script&lang=js"
export * from "./FreeTabIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports